import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { getTransactions } from '../api';
import { dollar } from '../util';
import { useAudio } from '../context/AudioManagementContext';

function RegistryItem({ id, onClick, title, source, cost = 0, quantity = 1 }) {
  const { playClick, playHover } = useAudio();
  const [sold, setSold] = useState(0);
  const [buyer, setBuyer] = useState('Anonymous');

  useEffect(() => {
    getTransactions(id, (transactions) => {
      if (transactions && transactions.length) {
        let sum = 0;
        let latest = 0;
        setBuyer(
          transactions[Math.floor(Math.random() * transactions.length)].name
        );
        transactions.forEach((transaction) => {
          sum += transaction.amount;
          if (latest < transaction.date.seconds) {
            latest = transaction.date.seconds;
          }
        });
        setSold(sum);
      }
    });
  }, [id, setSold]);

  const onClickWrapper = (event) => {
    if (event) {
      if (event.stopPropagation) event.stopPropagation();
      if (event.cancelable && !event.isDefaultPrevented())
        event.preventDefault();
    }

    playClick(0.5, () => onClick(id));
  };

  const onHover = () => {
    playHover(0.2);
  };

  const imagePath = require(`../asset/img/${source}`);
  const isSold = sold >= quantity;

  if (isSold) {
    return (
      <div
        className="registry-item pixel-corners-wrapper pixel-corners sold"
        onClick={onClickWrapper}
        onTouchStart={onClickWrapper}
      >
        <img src={imagePath} alt={source} />
        <div className="overlay">
          <h2>{title.toUpperCase()}</h2>
          <h1>SOLD</h1>
          <p>{dollar.format(cost)}</p>
          <p>{buyer}</p>
        </div>
      </div>
    );
  }

  return (
    <div
      className="registry-item pixel-corners-wrapper pixel-corners"
      onClick={onClickWrapper}
      onTouchStart={onClickWrapper}
      onMouseEnter={onHover}
    >
      <img src={imagePath} alt={source} />
      <div className="overlay">
        <h2>{title.toUpperCase()}</h2>
        <p>{quantity - sold} needed</p>
        <p>{dollar.format(cost)}</p>
      </div>
    </div>
  );
}

RegistryItem.propTypes = {
  id: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string,
  source: PropTypes.string,
  cost: PropTypes.number,
  quantity: PropTypes.number
};

export default RegistryItem;
